<kendo-dialog title="{{message.title}}" *ngIf="opened" (close)="close(null)" [minWidth]="minWidth" [width]="width" [height]="height" [maxHeight]="maxHeight">
	<p *ngIf="!html" style="margin: 1rem; text-align: center;">{{message.message}}</p>
	<div *ngIf="html" style="margin: 1rem;" [innerHTML]="message.message"></div>
	<kendo-dialog-actions>
		<button kendoButton *ngFor="let button of message.buttons"
			class="k-button-solid {{ button.name === message.defaultButton ? 'k-button-solid-primary' : 'k-button-solid-secondary' }}"
			[primary]="button.name === message.defaultButton ? true : undefined"
			(click)="close(button.name)">{{button.text}}</button>
	</kendo-dialog-actions>
</kendo-dialog>